import React from 'react';
import { string, bool } from 'prop-types';
import cx from 'classnames';
import styles from './LocationHeader.scss';

export default function LocationHeader({ name, isLoading }) {
  return (
    <div
      className={cx(styles.main, {
        [styles.isLoading]: isLoading,
      })}
    >
      <div className={styles.text}>
        <h1 className={styles.label}>Location</h1>
        <h2 className={styles.content}>
          {name}
        </h2>
      </div>
    </div>
  );
}

LocationHeader.propTypes = {
  name: string.isRequired,
  isLoading: bool,
};



// WEBPACK FOOTER //
// ./src/components/DataPanel/Details/LocationHeader/index.js